import TeaserCard from "./TeaserCard.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function Teaser(props) {
  props = useThemeProps({ props, name: "Teaser" });
  // eslint-disable-next-line no-console
  console.warn("<Teaser> is deprecated. Use <TeaserCard> instead.");
  return <TeaserCard {...props} />;
}
